declare global {
  interface String {
    replaceAt(index: number, replacement: string): string;
  }
}

// eslint-disable-next-line no-extend-native
String.prototype.replaceAt = function (index, replacement) {
  return (
    this.substring(0, index) +
    replacement +
    this.substring(index + replacement.length)
  );
};

// La config (window.__ENV__) est déjà chargée par public/index.html ;
// l'import dynamique garantit que le polyfill ci-dessus précède l'app.
import("./main.tsx");
